export default { sha: 'a2bf89619b6fbbcb0b8fa3b135ae820dca1f39af', buildNumber: 'undefined' }
